import { render, staticRenderFns } from "./TeacherItem.vue?vue&type=template&id=fd3a7422&scoped=true"
import script from "./TeacherItem.vue?vue&type=script&lang=ts"
export * from "./TeacherItem.vue?vue&type=script&lang=ts"
import style0 from "./TeacherItem.vue?vue&type=style&index=0&id=fd3a7422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a7422",
  null
  
)

export default component.exports